import { Component } from '@angular/core';
import { NavController, NavParams, ToastController  } from 'ionic-angular';
import { Globals } from '../../providers/globals';
import { BusinessInvoiceHandler } from '../../providers/business-invoice-handler';

@Component({
  selector: 'page-business-invoice-detail',
  templateUrl: 'business-invoice-detail.html',
})
export class BusinessInvoiceDetailPage {
	isLoading: boolean = false;

	invoice: any;
	invoiceDetail: any;

	constructor(
		public businessInvoiceHandler: BusinessInvoiceHandler, 
		public toastCtrl: ToastController,
		public navCtrl: NavController,
		public globals: Globals, 
		public navParams: NavParams) {

		this.invoice = navParams.data["invoice"];

		this.loadDetail();
	}

	loadDetail(){
		this.businessInvoiceHandler.getBusinessInvoiceDetail({id: this.invoice.Id})
		.then((data)=>{
			this.invoiceDetail = data;
		})
		.catch((err)=>{
			this.isLoading = false;	

			let toast = this.toastCtrl.create({
				message: 'There was an error: ' + err,
				duration: 3000,
				position: 'bottom'
			});

			toast.present();	
		});		
	}

}



// WEBPACK FOOTER //
// ./src/pages/business-invoice-detail/business-invoice-detail.ts